module.exports = __webpack_public_path__ + "img/42.f10baf30.png";